<template>
  <div class="main-container">
    <div class="header-container">
      <p class="header-paragraph">
        {{ $t('InfinityAI_DiscoverModels_Header') }}
      </p>
    </div>
    <div class="grid-container">
      <div class="grid-item" v-for="n in 6">
        <p class="title-paragraph">
          {{ $t(`InfinityAI_DiscoverModels_T${n}_Title`) }}
        </p>
        <p class="description-paragraph">
          {{ $t(`InfinityAI_DiscoverModels_T${n}_Description`) }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MlStudioDiscoverModels'
}
</script>
<style scoped>
.main-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 40px;
  padding: 40px 65px;
  background: #fff;
}
.header-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

.header-paragraph {
  color: #5c6374;
  font-size: 24px;
  font-weight: 600;
  line-height: 30px;
}

.grid-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: 20px;
  row-gap: 20px;
}

.grid-item {
  flex: 0 0 33.3333%;
  width: 256px;
  height: 230px;
  border-radius: 4px;
  border: 1px solid #dbdee7;
  box-sizing: border-box;
  text-align: center;
}

.title-paragraph {
  color: #5c6374;
  font-size: 18px;
  font-weight: 600;
  line-height: 30px;
  margin-top: 30px;
}

.description-paragraph {
  color: #7e8596;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  margin: 5px 20px 0px 20px;
}
</style>



// WEBPACK FOOTER //
// src/modules/ml-studio/components/MlStudioDiscoverModels.vue